/**
 * @generated SignedSource<<d175ee77c6747c54245cea3a08cd123d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateExpectedSourceInputObject = {
  name: string;
  note?: string | null | undefined;
};
export type statementsPage_CreateExpectedSourceMutation$variables = {
  input: CreateExpectedSourceInputObject;
};
export type statementsPage_CreateExpectedSourceMutation$data = {
  readonly createExpectedSource: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly expectedSource: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type statementsPage_CreateExpectedSourceMutation = {
  response: statementsPage_CreateExpectedSourceMutation$data;
  variables: statementsPage_CreateExpectedSourceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpectedSource",
  "kind": "LinkedField",
  "name": "expectedSource",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "statementsPage_CreateExpectedSourceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateExpectedSourceMutationPayload",
        "kind": "LinkedField",
        "name": "createExpectedSource",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "statementsPage_CreateExpectedSourceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateExpectedSourceMutationPayload",
        "kind": "LinkedField",
        "name": "createExpectedSource",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e95d3d6ffa300d4b154ce535d01cc774",
    "id": null,
    "metadata": {},
    "name": "statementsPage_CreateExpectedSourceMutation",
    "operationKind": "mutation",
    "text": "mutation statementsPage_CreateExpectedSourceMutation(\n  $input: CreateExpectedSourceInputObject!\n) {\n  createExpectedSource(input: $input) {\n    expectedSource {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "15cd740dcde4dc44f4ddbcd154131cf1";

export default node;
